import { UUID } from './uuid';

const entityMap: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&#34;',
    '\'': '&#39;',
};

export function Escape(s: string): string {
    return s.replace(/[&<>"']/g, s => entityMap[s]);
}

export function Nl2br(s: string): string {
    return s.replace(/(\r\n|\r|\n)/g, '<br>$1');
}

export function FromString<T extends HTMLElement>(s: string): T {
    const template = document.createElement('template');
    template.innerHTML = s;

    return template.content.firstElementChild as T;
}

export function Print(html: string, title?: string) {
    const w = window.open('', '', 'height=816,width=1056');
    if (!w) {
        throw new Error('something stopped the print window from appearing');
    }

    w.document.write(html);

    if (title) {
        w.document.title = title;
    }

    const print = () => {
        clearTimeout(printTimeout);
        w.document.close();

        setTimeout(() => {
            w.print();
            setTimeout(() => w.close(), 500);
        }, 500);
    };

    const printTimeout = setTimeout(() => print(), 1000);

    const css = w.document.querySelectorAll('link[rel="stylesheet"]');
    const img = w.document.querySelectorAll('img');

    const totalElements = img.length + css.length;

    if (totalElements === 0) {
        print();
    }

    let i = 0;
    const checkLoad = () => {
        if (++i === totalElements) {
            print();
        }
    };

    css.forEach(c => {
        c.addEventListener('load', () => {
            checkLoad();
        });

        c.addEventListener('error', () => {
            checkLoad();
        });
    });

    img.forEach(i => {
        i.addEventListener('load', () => {
            checkLoad();
        });

        i.addEventListener('error', () => {
            checkLoad();
        });
    });
}

export function IDsToClasses(el: HTMLElement) {
    const uuid = UUID();

    el.querySelectorAll('[id]:not([id=""])').forEach(el => {
        el.classList.add(el.id);
        el.id = `${el.id}-${uuid}`;
    });
    el.querySelectorAll('label[for]:not([for=""])').forEach(el =>
        el.setAttribute('for', `${el.getAttribute('for') ?? ''}-${uuid}`));
}

export function UnHTML(html: string): string {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;

    tmp.querySelectorAll('div').forEach($ => {
        $.parentElement?.insertBefore(document.createTextNode('\n'), $.nextSibling);
    });

    tmp.querySelectorAll('p').forEach($ => {
        $.parentElement?.insertBefore(document.createTextNode('\n\n'), $.nextSibling);
    });

    let text = tmp.innerText || tmp.textContent || '';
    text = text.trim();
    text = text.replace(/\n\n{3,}/g, '\n\n');

    return text;
}

/**
 * Converts a string to a valid HTML anchor. Based on the Hugo function urls.Anchorize: https://gohugo.io/functions/urls/anchorize/
 */
export function Anchorize(input: string) {
    return input.
        normalize('NFD').                 // Decompose unicode characters
        replace(/[\u0300-\u036f]/g, '').  // Remove combining diacritical marks and accents
        replace(/[^a-zA-Z0-9]+/g, '-').   // Replace non-alphanumeric characters with dashes
        replace(/^-+|-+$/g, '').          // Remove leading and trailing dashes
        replace(/^([^a-zA-Z])/, 'id-$1'). // Prepend 'id-' if the first character is not a letter
        toLowerCase();
}